import { HTTP } from './http-common';

export default {
  getCreditScore() {
    return HTTP.get(`/miQnt/creditScore/current_score-history/`);
  },
  getCreditScoreDetail() {
    return HTTP.get(`/qnt/credit_score/details/`);
  },
}